import { blue } from "@faro-lotv/flat-ui";
import { Box, Stack } from "@mui/system";
import type { JSX } from "react";
import { CursorProps } from "react-arborist";

/**
 * @returns The line cursor shown when dragging an element inside a folder in the tree.
 *  It is kept inside the tree, as otherwise the circle is cut off at the root level and at the
 *  first position: its shadow reaches 3px beyond the left and 5px beyond the top of the position.
 */
export function CaptureTreeDragCursor({
  top,
  left,
  indent,
}: CursorProps): JSX.Element {
  return (
    <Stack
      direction="row"
      sx={{ alignItems: "center" }}
      style={{
        zIndex: 1,
        position: "absolute",
        pointerEvents: "none",
        top: `${Math.max(top, 5) - 2}px`,
        left: `${Math.max(left, 3)}px`,
        right: `${indent}px`,
      }}
    >
      <Box
        component="div"
        style={{
          width: "4px",
          height: "4px",
          boxShadow: `0 0 0 3px ${blue[400]}`,
          borderRadius: "50%",
        }}
      />
      <Box
        component="div"
        style={{
          flex: 1,
          height: "2px",
          background: blue[400],
          borderRadius: "1px",
        }}
      />
    </Stack>
  );
}
